import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

const updatePrice = async ({
  id,
  body,
}: {
  id: string;
  body: ApiDefinition['/prices/{priceId}']['PUT']['body'];
}): Promise<ApiDefinition['/prices/{priceId}']['PUT']['response']> => {
  const data = await noodleApiClient.put(`/prices/${id}`, body);
  return data.data;
};

export default updatePrice;
